"use client";
import Image from "next/image";
import GetInstantQuoteButton from "@/components/Contact/GetInstantQuote";
import React from "react";

const GetQuteTip = ({
	tip,
	className,
	parentClass,
}: {
	tip: string;
	className?: string;
	parentClass?: string;
}) => {
	return (
		<div
			className={`container my-10 flex items-center justify-between gap-x-2 max-md:flex-wrap max-md:py-1 ${parentClass}`}
		>
			<Image
				src="/image/service/tips.png"
				width={25}
				height={20}
				alt="material Selection bottom"
				quality={50}
				className="h-[24px] w-[25px] object-cover"
			></Image>
			{/*<BulbOutlined className="!text-themeWarning500 font-bold text-3xl" />*/}
			<div className={`text-[15px] font-bold ${className} max-md:py-3`}>
				<p>{tip}</p>
			</div>
			<GetInstantQuoteButton></GetInstantQuoteButton>
		</div>
	);
};
export default GetQuteTip;
